<template>
  <div style="height: 100%; overflow-y: auto">
    <avue-divider :column="column" style="display: none"></avue-divider>
    <view-form v-if="formvisible" ref="viewForm" :view-form-data="viewFormData" @formClose="formClose">
      <template slot="save">
        <el-button v-if="!signData.isSign && viewFormData.pageKey === 'DO'" @click="handleSave"
          type="primary">保存</el-button>
      </template>
      <template slot="saveAndSubmit">
        <el-button v-if="viewFormData.pageKey === 'DO'" type="primary" @click="handleSaveAndSubmit">保存并提交</el-button>
      </template>

    </view-form>

    <el-dialog :visible.sync="submitAgainVisible" :modal-append-to-body="false">

      <div>
        {{infoFromStartWorkflow}}
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose()">取消提交</el-button>
        <el-button type="primary" @click="handleSubmitAgain()">确认提交</el-button>
      </span>
    </el-dialog>

    <sign-dialog :config-info="signInfo" @handleSubmit="handleSubmit">

    </sign-dialog>

  </div>
</template>


<script>
import { loadJs, changeFormModelUsingTaskForm, setHeaderBeforeFileUpload, controlHideByCondition, uploadBefore, uploadAfter, changeConfigToForm, setMode, donwloadFileOnClick, modifyFormModelData, cascadeLocal } from "@/workFlow/utils/formUtil";
import { getToken } from "@/framework/util/auth";
/* import {getButtonAuthority, initButtonDialog, terminateProcess, revokePreTask, addSign, deleteSign, delegateTask, undoDelegateTask, turnTask} from "@/views/workflow/flow/util/FlowUtil";
 import transfer from '@/workFlow/workFlow/formComponent/formTransfer/fromtransfer'
 import buttonTransfer from '@/workFlow/workFlow/formComponent/formTransfer/fromtransfer'
*/

import viewForm from '@/workFlow/formComponent/viewForm/ViewForm.vue'
import signDialog from '../../EvaluationManage/InternalComponent/confirmDialog'

export default {

  components: { viewForm, signDialog },

  watch: {


  },

  data() {
    return {
      column: {
        dalign: 'center',
      },
      viewFormData: {
        options: {},
        modeldata: {},
        pageKey: '',
        row: {}
      },
      formvisible: false,
      options: {},
      modeldata: {},
      signData: {},//会签数据
      signInfo: {//会签提交表单配置
        confirmVisible: false,
        options: {},
        modeldata: {},
        buttonSetting: {
          buttomButtonName: '保存并提交'
        }
      },
      infoFromStartWorkflow: "",
      submitAgainVisible: false,
    }
  },

  mounted() {
    let { row, pageKey } = this.$route.params
    if (!(row && pageKey)) {
      this.$message.error('缺失参数,请联系管理员')
      this.$router.push({ path: '/404' })
    }
    this.viewFormData.pageKey = pageKey

    if (pageKey === 'VIEW')//查看的表单
    {
      this.getViewFormData(row)
    } else if (pageKey === 'DO')//办理表单
    {
      this.getTodoFormData(row)
    }


    /*modifyFormModelData(this.viewFormData.options, this.transferConf)
    changeConfigToForm(document.getElementsByTagName('label'), this.viewFormData.options)
    setTimeout(() => {
        donwloadFileOnClick(this.$refs.avueform, this.$downloadFile, this.viewFormData.modeldata, this.$message)
    }, 600)*/

  },
  created() {

  },

  methods: {
    handleSubmit() {
      console.log(this.signInfo.options)
      this.signInfo.modeldata.processInstanceId = this.row.processInstanceId
      this.signInfo.modeldata.taskId = this.row.taskId
      console.log(this.signInfo.modeldata)

      this.$http.post('/form-instance/sign-save?formId=' + this.signInfo.options.formId, this.signInfo.modeldata).then(response => {
        if (response.code === 200) {
          console.log('sign save ')
          console.log(response)
          let taskData = response.data
          this.$http.post('/flow-ext/do-task?taskId=' + this.row.taskId, taskData).then(response => {
            if (response.code === 200) {
              this.signInfo.confirmVisible = false
              this.formvisible = false
              this.tableVisible = true
              /*setTimeout(() => {
                  this.mainTableReload(this.$refs.mainTable.getReloadConditions())
              })*/
              this.$router.go(-1)
              this.$message.info(response.msg)
            } else {
              this.$message.error(response.code + response.msg)
            }
          }).catch(err => {
            if (err.code === 1101) {
              this.submitAgainVisible = true
              this.infoFromStartWorkflow = err.msg
            } else {
              this.$message.error(err.msg)
            }
          })
          this.signInfo.confirmVisible = false
        } else {
          this.$message.error(response.msg)
        }
      }).catch(err => {
        if (err.msg) {
          this.$message.error(err.msg)
        } else {
          this.$message.error(err.message)
        }
      })
    },
    handleSubmitAgain() {
      this.submitAgainVisible = false
      this.taskData.verifyFlag = '2'
      this.$http.post('/flow-ext/do-task?taskId=' + this.row.taskId, this.taskData).then(response => {
        if (response.code === 1101) {//校验不通过
          console.log(response.code)
          console.log(response)
          this.submitAgainVisible = true
          this.infoFromStartWorkflow = response.msg
        } else if (response.code === 200) {
          this.formvisible = false
          this.tableVisible = true
          /*setTimeout(() => {
              this.mainTableReload(this.$refs.mainTable.getReloadConditions())
          })*/
          this.$router.go(-1)
          this.$message.info(response.msg)
        } else {
          this.$message.error(response.code + response.msg)
        }
      }).catch(err => {
        if (err.msg)
          this.$message.error(err.msg)
        else
          this.$message.error(err.message)
      })
    },
    handleClose() {
      this.submitAgainVisible = false
    },
    getTodoFormData(row) {

      console.log("row")
      console.log(row)
      this.row = row
      this.$http.get('/form-instance/select', { params: { dataId: row.businessKey, formId: row.taskFormKey[0] } }).then(response => {
        if (response.code === 200) {
          this.modeldata = response.data
          this.modeldata.processInstanceId = row.processInstanceId
          this.modeldata.taskId = row.taskId
          this.$http.get("/flow-ext/todo-task-description", { params: { businessKey: row.businessKey, taskId: row.taskId } }).then(response => {
            if (response.code === 200) {
              console.log('todo-task-description')
              console.log(response)

              //this.tableVisible = false
              if (response.data.formKeyList.length === 1) {
                this.signData.isSign = false
              } else if (response.data.formKeyList.length > 1) {//会签模式数据保存
                this.signData.isSign = true
                this.signData.data = response.data
              }
              let formModelJson = response.data.formModelJsonList
              let taskFormJson = response.data.taskFormPropertyList
              changeFormModelUsingTaskForm(formModelJson[0], taskFormJson)
              loadJs(formModelJson[0])
              this.options = formModelJson[0]
              setHeaderBeforeFileUpload(this.options, getToken())//设置文件上传时的token
              setTimeout(() => {
                this.viewFormData.options = this.options
                this.viewFormData.modeldata = this.modeldata
                this.viewFormData.pageKey = 'DO'
                this.viewFormData.row = row
                this.formvisible = true
              }, 600)

            } else {
              this.$message.error(response.code + response.msg)
            }

          }).catch(err => {
            if (err.msg)
              this.$message.error(err.msg)
            else
              this.$message.error(err.message)
          })
        } else {
          this.$message.error(response.code + response.msg)
        }
      }).catch(err => {
        if (err.msg)
          this.$message.error(err.msg)
        else
          this.$message.error(err.message)
      })


    },

    getViewFormData(row) {
      if (row.form_KEY_ && row.form_KEY_.length > 0) {
        if (row.taskName === '已完成') {
          this.$message.info('任务已完成')
          return
        }
        this.getFormData(row.form_KEY_, row.id, row)
        /*this.$http.get('/form-instance/select', {params: {'dataId': row.id, 'formId': row.form_KEY_}}).then(response => {
            if(response.code === 200){
                this.modeldata = response.data
                this.$http.get('/form-model/detail', {params: {'formId': row.form_KEY_}}).then(response => {
                    if(response.code === 200){
                        this.options = response.data.modelJson
                        if(this.options.column && this.options.column.length > 0){
                            for(let i = 0; i < this.options.column.length; i++){
                                this.options.column[i].disabled = true
                            }
                        }
                        changeFormModelUsingTaskForm(this.options, [])
                        loadJs(this.options)
                        setTimeout(() => {
                            this.viewFormData.options = this.options
                            this.viewFormData.modeldata = this.modeldata
                            this.viewFormData.pageKey = 'VIEW'
                            this.viewFormData.row = row
                            this.viewFormData.modeldata.processInstanceId = row.processInstanceId
                            this.viewFormData.modeldata.taskId = row.taskId
                            this.formvisible = true
                            this.tableVisible = false
                        },600)
                    }
                })
            }
        })*/
      } else {
        this.$http.get('/flow-ext/process-form-key', { params: { 'processInstanceId': row.processInstanceId } }).then(response => {
          if (response.code === 200) {
            let formId = response.data
            this.getFormData(row.businessKey, formId, row)
            /*this.$http.get('/form-model/detail', {params: {'formId': response.data}}).then(response => {
                if(response.code === 200){
                    for(let i = 0; i < response.data.modelJson.column.length; i++){
                        response.data.modelJson.column[i].disabled = true
                    }
                    this.options = response.data.modelJson
                    loadJs(this.options)
                    changeFormModelUsingTaskForm(this.options, [])
                    this.$http.get('/form-instance/select', {params: {'dataId': row.businessKey, 'formId': formId}}).then(response => {
                        if(response.code === 200){

                            console.log('response')
                            console.log(response)
                            /!*setTimeout(() => {*!/
                            this.modeldata = response.data
                            this.viewFormData.options = this.options
                            this.viewFormData.modeldata = this.modeldata
                            this.viewFormData.modeldata.processInstanceId = row.processInstanceId
                            this.viewFormData.modeldata.taskId = row.taskId
                            this.viewFormData.pageKey = 'VIEW'
                            this.viewFormData.row = row
                            this.formvisible = true
                            setTimeout(() => {
                                changeConfigToForm(document.getElementsByTagName('label'), this.viewFormData.options)
                            },600)
                            // }, 600)
                        }else {
                            this.$message.error(response.code + response.msg)
                        }
                    }).catch(error => {
                        if(error.msg)
                            this.$message.error(error.msg)
                        else
                            this.$message.error(error.message)
                    })
                }else {
                    this.$message.error(response.code + response.msg)
                }
            }).catch(error => {
                if(error.msg)
                    this.$message.error(error.msg)
                else
                    this.$message.error(error.message)
            })*/
          } else {
            this.$message.error(response.code + response.msg)
          }
        }).catch(error => {
          if (error.msg)
            this.$message.error(error.msg)
          else
            this.$message.error(error.message)
        })
      }
      //getButtonAuthority(this.authButtonDisplay, this.$http, this.$message, '/flow-task-change/view-form-button-authority?processInstanceId='+row.processInstanceId)

    },
    getFormData(businessKey, formId, row) {
      this.$http.get('/form-model/detail', { params: { 'formId': formId } }).then(response => {
        if (response.code === 200) {
          for (let i = 0; i < response.data.modelJson.column.length; i++) {
            response.data.modelJson.column[i].disabled = true
          }
          this.options = response.data.modelJson
          loadJs(this.options)
          changeFormModelUsingTaskForm(this.options, [])
          this.$http.get('/form-instance/select', { params: { 'dataId': businessKey, 'formId': formId } }).then(response => {
            if (response.code === 200) {

              console.log('response')
              console.log(response)
              setTimeout(() => {
                this.modeldata = response.data
                this.viewFormData.options = this.options
                this.viewFormData.modeldata = this.modeldata
                this.viewFormData.modeldata.processInstanceId = row.processInstanceId
                this.viewFormData.modeldata.taskId = row.taskId
                this.viewFormData.pageKey = 'VIEW'
                this.viewFormData.row = row
                this.formvisible = true
                /*setTimeout(() => {
                    changeConfigToForm(document.getElementsByTagName('label'), this.viewFormData.options)
                },600)*/
              }, 600)
            } else {
              this.$message.error(response.code + response.msg)
            }
          }).catch(error => {
            if (error.msg)
              this.$message.error(error.msg)
            else
              this.$message.error(error.message)
          })
        } else {
          this.$message.error(response.code + response.msg)
        }
      }).catch(error => {
        if (error.msg)
          this.$message.error(error.msg)
        else
          this.$message.error(error.message)
      })
    },

    handleSaveAndSubmit() {
      this.modeldata.taskId = this.row.taskId
      this.modeldata.processInstanceId = this.row.processInstanceId
      this.modeldata.assigneeList = ["wipadmin", "25AA415B48C54CB89B88B0A941D44560"]
      this.viewFormData.modeldata.assigneeList = this.modeldata.assigneeList
      console.log(this.viewFormData.modeldata)
      //return
      this.$refs.viewForm.$refs.avueform.$children[0].validate((valid, invalidaData) => {
        /*console.log('hello')
        console.log(invalidaData)
        console.log(this.$refs.viewForm.$refs.avueform)*/
        if (valid) {
          if (this.signData.isSign) {//会签模式数据保存和提交
            this.signInfo.confirmVisible = true
            this.signInfo.options = this.signData.data.formModelJsonList[this.signData.data.formModelJsonList.length - 1]//会签模式，展示最后一个表单
            //会签环节，会签人： assigenlist,
          } else {//非会签环节数据保存和提交
            this.$http.post('/form-instance/save?formId=' + this.row.taskFormKey[0], this.viewFormData.modeldata).then(response => {
              if (response.code === 200) {
                this.taskData = response.data
                //return
                console.log(JSON.stringify(this.taskData))
                this.$http.post('/flow-ext/do-task?taskId=' + this.row.taskId, this.taskData).then(response => {
                  if (response.code === 200) {
                    this.formvisible = false
                    this.$router.go(-1)
                    /*setTimeout(() => {
                        this.mainTableReload(this.$refs.mainTable.getReloadConditions())
                    })*/
                    this.$message.info(response.msg)
                  } else {
                    this.$message.error(response.code + response.msg)
                  }
                }).catch(err => {
                  if (err.code === 1101) {
                    this.submitAgainVisible = true
                    this.infoFromStartWorkflow = err.msg
                  } else {
                    if (err.msg)
                      this.$message.error(err.msg)
                    else
                      this.$message.error(err.message)
                  }
                })
              } else {
                this.$message.error(response.msg)
              }
            }).catch(err => {
              if (err.msg)
                this.$message.error(err.msg)
              else
                this.$message.error(err.message)
            })
          }
        } else {
          let childrenList = this.$refs.viewForm.$refs.avueform.$children[0].$children[0].$children[0].$children[0].$children
          for (let key in invalidaData) {
            for (let i = 0; i < childrenList.length; i++) {
              if (!childrenList[i].$children[0] || !childrenList[i].$children[0].$children[1] || childrenList[i].$children[0].$children[1].$children[0].$children[0] === undefined) {
                continue
              }
              if (childrenList[i].$children[0].$children[1].$children[0].$children[0].prop === invalidaData[key][0].field) {
                console.log(childrenList[i].$children[0].$children[1].$children[0].$children[0])
                //let focusFunc = eval(childrenList[i].$children[0].$children[1].$children[0].$children[0].$children[0].focus)
                try {
                  childrenList[i].$children[0].$children[1].$children[0].$children[0].$children[0].focus()
                  return
                } catch (err) {
                  this.$message.info(invalidaData[key][0].message)
                  return
                }

              }
            }
          }
        }
      })


    },
    handleSave() {
      this.$refs.viewForm.$refs.avueform.$children[0].validate((valid, invalidaData) => {
        if (valid) {
          if (!this.signData.isSign) {
            this.modeldata.taskId = this.row.taskId
            this.modeldata.processInstanceId = this.row.processInstanceId
            this.$http.post('/form-instance/save?formId=' + this.row.taskFormKey[0], this.viewFormData.modeldata).then(response => {
              if (response.code === 200) {
                this.$message.info(response.msg)
                //表单保存时，当前页面不关闭
                /*this.formvisible = false
                this.tableVisible = true*/
                //this.mainTableReload(this.$refs.mainTable.getReloadConditions())
              } else {
                this.$message.error(response.code + response.msg)
              }
            }).catch(err => {
              if (err.msg)
                this.$message.error(err.msg)
              else
                this.$message.error(err.message)
            })
          } else {//会签中表单数据保存
            this.$http.post('/form-instance/sign-save?formId=' + this.row.taskFormKey[0], this.modeldata).then(response => {
              if (response.code === 200) {
                this.$message.info(response.msg)
                //表单保存时，当前页面不关闭
                /*this.formvisible = false
                this.tableVisible = true*/
                //this.mainTableReload(this.$refs.mainTable.getReloadConditions())
              } else {
                this.$message.error(response.code + response.msg)
              }
            }).catch(err => {
              this.$message.error("error" + err.msg)
            })
          }
        } else {
          let childrenList = this.$refs.viewForm.$refs.avueform.$children[0].$children[0].$children[0].$children[0].$children
          for (let key in invalidaData) {
            for (let i = 0; i < childrenList.length; i++) {
              if (!childrenList[i].$children[0] || !childrenList[i].$children[0].$children[1] || childrenList[i].$children[0].$children[1].$children[0].$children[0] === undefined) {
                continue
              }
              if (childrenList[i].$children[0].$children[1].$children[0].$children[0].prop === invalidaData[key][0].field) {
                console.log(childrenList[i].$children[0].$children[1].$children[0].$children[0])
                //let focusFunc = eval(childrenList[i].$children[0].$children[1].$children[0].$children[0].$children[0].focus)
                try {
                  childrenList[i].$children[0].$children[1].$children[0].$children[0].$children[0].focus()
                  return
                } catch (err) {
                  this.$message.info(invalidaData[key][0].message)
                  return
                }

              }
            }
          }
        }
      })



    },
  }

}


</script>
<style lang="scss" scoped>
:deep(.drawer-foot) {
  position: absolute;
  /*bottom: 0;
        left: 0;
        right: 0;*/
  margin-top: 20px;
  //display: flex;

  button {
    width: 50%;
  }
}

.audit_step {
  position: absolute;
  top: 150px;
  right: 10px;
  left: 820px;
  margin-bottom: 10px;
  background-color: white;
  z-index: 90;
}

.button-top {
  text-align: right;
  position: absolute;
  top: 35px;
  right: 23px;
  display: flex;
  z-index: 90;
}

.drawer-top {
  position: relative;
  height: 60px;
  margin-top: 50px;
  text-align: center;
}

:deep(.preview-form) {
  padding-top: 20px;
  /*overflow-y: auto;*/
  padding-bottom: 20px;
  height: 90%;
}
:deep(.avue-crud) {
  padding-bottom: 18px;
}
.bold_input :deep(.el-input__inner) {
  font-weight: bolder !important;
}
:deep(.el-textarea__inner) {
  font-weight: bolder !important;
}
</style>
